import Skeleton from '../skeleton/Skeleton';
import { StyledAiHome } from './AiHome.styles';

/**
 * The opening screen's shape — top line, greeting, the first page of
 * suggestions and the composer — shown until the thread list, the provider
 * and the input limits have all arrived and the landing chat is open. The
 * sidebar starts closed, so it is not drawn.
 */
const AiHomeSkeleton = () => (
  <StyledAiHome $sidebarOpen={false} aria-busy="true">
    <div className="ai-workspace">
      <main className="ai-main">
        <div className="ai-glow" aria-hidden />
        <div className="ai-topline">
          <div className="ai-topline-left" />
          <div className="ai-topline-right">
            <Skeleton width="148px" height="32px" radius="999px" />
          </div>
        </div>

        <div className="ai-conversation-wrap">
          <div className="ai-conversation is-empty">
            <div className="ai-empty">
              <Skeleton width="132px" height="44px" radius="12px" />
              <Skeleton width="300px" height="40px" radius="10px" margin="28px 0 0" resp />
              <Skeleton width="420px" height="40px" radius="10px" margin="10px 0 0" resp />
              <Skeleton width="400px" height="14px" radius="6px" margin="16px 0 0" resp />
              <Skeleton width="320px" height="14px" radius="6px" margin="8px 0 0" resp />
              <div className="suggestions">
                <div className="quick-actions">
                  {[0, 1, 2, 3].map(key => (
                    <Skeleton key={key} width="100%" height="62px" radius="18px" />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ai-composer-wrap">
          <div className="ai-composer-inner">
            <Skeleton width="100%" height="112px" radius="22px" />
          </div>
        </div>
      </main>
    </div>
  </StyledAiHome>
);

export default AiHomeSkeleton;
